import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import {
  Button,
  BUTTON_THEME,
  BUTTON_SIZE,
  IconButton,
  ICON_TYPES,
  Slider as RangeSlider,
} from '@st-operations/uikit/src/v2/index.js'
import format from '@st-operations/uikit/lib/format.js'
import { useDropdown } from '_hooks'

import './styles.scss'

const FilterTopicsButton = ({ className, classes, onFilter }) => {
  const { isOpen, handleOpen, dropdownRef } = useDropdown()
  const [slider, setSlider] = useState(0)
  const handleClearAll = () => setSlider(0)

  useEffect(() => {
    onFilter(slider)
  }, [slider])

  return (
    <div className={classnames('filter-topics-button', className, classes?.root)}>
      <IconButton
        iconProps={{ icon: 'filter', type: ICON_TYPES.OUTLINE, width: '24px', height: '24px' }}
        className="filter-topics-button__icon"
        onClick={handleOpen}
        isActive={isOpen || slider > 0}
        ariaLabel="Filter topics"
        text="Filter"
        key="sort-button"
      />

      <If condition={isOpen}>
        <section
          className={classnames('filter-topics-button__dropdown', classes?.dropdown)}
          key="filter-dropdown"
          ref={dropdownRef}
        >
          <header className="filter-topics-button__header">
            <h1 className="filter-topics-button__title">Filters</h1>
            <Button
              size={BUTTON_SIZE.SMALLEST}
              className="filter-topics-button__clear"
              theme={BUTTON_THEME.GHOST}
              onClick={handleClearAll}
            >
              Clear all
            </Button>
          </header>
          <main className="filter-topics-button__main">
            <div className="filter-topics-button__labels">
              <p className="filter-topics-button__description">Minimum number of users</p>
              <p className="filter-topics-button__value">{format('metric', slider)}</p>
            </div>
            <RangeSlider
              value={slider}
              minValue={0}
              maxValue={1000000}
              step={50000}
              onChange={setSlider}
              tooltip={format('metric', slider)}
            />
            <div className="filter-topics-button__labels">
              <p className="filter-topics-button__slider-text">0</p>
              <p className="filter-topics-button__slider-text">1M</p>
            </div>
          </main>
        </section>
      </If>
    </div>
  )
}

FilterTopicsButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    icon: PropTypes.string,
  }),
  onFilter: PropTypes.func,
}

FilterTopicsButton.defaultProps = {
  className: '',
  classes: {},
  onFilter: () => {},
}

export default React.memo(FilterTopicsButton)
